export default __webpack_public_path__ + "static/media/spark_83.1c001fcc.png";